import { SearchParams } from '@/types'
import { ex } from '@fullcalendar/core/internal-common'

export interface IDiagnosticState {
  loading: boolean
  error: any | null
  controllers: Controller[]
  subInterfaces: SubInterface[]
  selectedSubInterface: SubInterface | null
}

export const initialState: IDiagnosticState = {
  loading: false,
  error: null,
  controllers: [],
  subInterfaces: [],
  selectedSubInterface: null,
}

export interface SearchController extends SearchParams {
  interfaceId: number
  isRequiredStation?: boolean
  stationId?: number
  Purpose?: number[]
  type?: number
}

export interface Controller {
  id: string
  name: string
  address: string
  index: string
  decoderType: string
  type: string
  configuration: string
  configState: string
  attention: number
  value: number
  interfaceId: string
  locationId: number
  controllerConfigure: string
  controllerConfigureId: number
  configurationId: number
  decoderTypeId: number
  typeId: number
  discoverState: string
  twiId: number
  twiCustomName?: string
}

export interface SubInterface {
  twId: string
  interfaceId: number
  name: string
  customName: string
  interfaceDetail: InterfaceDetail | null
}

export interface InterfaceDetail {
  organizationId: string
  weatherLinkStations: string[]
  updatedAt: string
  pictureFileName: string
  pictureUrl: string
  timeZoneId: string
  timeZoneOriginId: string
  customName: string
  state: string
}
